(function(){
  "use strict";

  angular.module('irricrops')
    .controller("dialogTimetablePdfCtrl", ["$scope", "casetas", "$mdDialog", "urls","$http","File",
        function($scope, casetas, $mdDialog, urls, $http, File){
          $scope.casetas = casetas;
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
          $scope.answer = function(answer) {
            $mdDialog.hide(answer);
          };
          $scope.descargarPdf = function(caseta){
            if(!caseta.loading){
              var fecha = moment(new Date()).startOf('week').toDate();
              File.download(
                  urls.BASE+'/pdf/orden-riego',
                  {
                    caseta_id: caseta.id,
                    filename: caseta.nombre+"_"+moment(fecha).format('DD MMM YYYY')+".pdf",
                    fecha: fecha
                  },
                  function(){
                    caseta.loading = true;
                  },
                  function(){
                    //success
                    caseta.loading = false;
                  },
                  function(){
                    //error
                    caseta.loading = false;
                  }
                );
            }
          };

        }]);
})();
